"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __enums_1 = require("../../../../__types/__enums");
const createReport_1 = require("../../../__common/createReport");
const getElasticsearchQueryFromFilters_1 = require("../../../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const getElasticsearchSortForSortParams_1 = require("../../../__common/elasticsearchQuery/getElasticsearchSortForSortParams");
const reportHelpers_1 = require("../../../__common/reportHelpers");
const LiveClassHelper_1 = require("../../common/LiveClassHelper");
function getAllLiveClassReports(rp, input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { ReportParams: reportParmas, ReportProjection = {} } = input;
        const { liveClassProjection = {}, relatedUserProjection } = ReportProjection;
        const { filters } = reportParmas;
        const sortParams = input.SortParams;
        const query = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(filters.liveClassFilters);
        if (Object.keys(query.bool).length > 0) {
            const { liveClasses, total } = yield LiveClassHelper_1.getLiveClassUsingQueryWithScroll({
                requestType: __enums_1.ReportRequestTypeEnum.ALL,
                _source: liveClassProjection,
                size: 1500,
                body: { query },
                sort: getElasticsearchSortForSortParams_1.getElasticsearchSortForSortParams(sortParams || [])
            });
            if (relatedUserProjection) {
                yield reportHelpers_1.setRelatedUsers(rp, ReportProjection.relatedUserProjection, liveClasses);
            }
            return createReport_1.createLiveClassReport({ liveClasses, total });
        }
        return createReport_1.createLiveClassReport({ liveClasses: [], total: 0 });
    });
}
exports.getAllLiveClassReports = getAllLiveClassReports;
//# sourceMappingURL=index.js.map